import type { ReactElement } from "react";

import { AssetsService } from "app/services/AssetsService";

const composeSolutionSwitcherIcon = (iconName: string): ReactElement => (
    <img
        src={AssetsService.assetUrl(`images/solution-switcher/${iconName}`)}
        alt={""}
    />
);

export const WebIntelligenceIcon = () => composeSolutionSwitcherIcon("web-intelligence.svg");
export const AppIntelligenceIcon = () => composeSolutionSwitcherIcon("app-intelligence.svg");
export const SalesIntelligenceIcon = () => composeSolutionSwitcherIcon("sales-intelligence.svg");
export const StockIntelligenceIcon = () => composeSolutionSwitcherIcon("stock-intelligence.svg");
export const MarketplaceIntelligenceIcon = () => composeSolutionSwitcherIcon("marketplace-intelligence.svg");
const CustomInsightsIcon = () => composeSolutionSwitcherIcon("custom-insights.svg");
export const ApiIcon = () => composeSolutionSwitcherIcon("daas.svg");
